// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5848514e] .v-pagination__item,[data-v-5848514e] .v-pagination__navigation{box-shadow:0 1px 0 #bdbdbd,0 0 0 1px #f5f5f5}[data-v-5848514e] .v-pagination__item:focus,[data-v-5848514e] .v-pagination__navigation:focus{outline:none}[data-v-5848514e] .v-pagination__item--active{box-shadow:0 1px 0 #0096cc}", ""]);
// Exports
module.exports = exports;
